// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page_YLFlr","content":"Page_content_GUEtb"};